(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('compendium-report-group', {
            parent: 'entity',
            url: '/compendium-report-group',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CompendiumReportGroups'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-groups.html',
                    controller: 'CompendiumReportGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('compendium-report-group-detail', {
            parent: 'entity',
            url: '/compendium-report-group/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CompendiumReportGroup'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-detail.html',
                    controller: 'CompendiumReportGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CompendiumReportGroup', function($stateParams, CompendiumReportGroup) {
                    return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'compendium-report-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('compendium-report-group-detail.edit', {
            parent: 'compendium-report-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumReportGroup', function(CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-report-group.new', {
            parent: 'compendium-report-group',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compendium-report-group', null, { reload: 'compendium-report-group' });
                }, function() {
                    $state.go('compendium-report-group');
                });
            }]
        })
        .state('compendium-report-group.edit', {
            parent: 'compendium-report-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumReportGroup', function(CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-report-group', null, { reload: 'compendium-report-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-report-group.delete', {
            parent: 'compendium-report-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-delete-dialog.html',
                    controller: 'CompendiumReportGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumReportGroup', function(CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-report-group', null, { reload: 'compendium-report-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
